import React from "react"
import ReactDOM from "react-dom/client"

import App from "./App"
import ENV from "./env"

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

console.log("App version:", (ENV.VITE_APP_VER as any)?.replaceAll('"', ""))
console.log("Git hash:", ENV.VITE_GIT_HASH?.substring(0, 6))
